import env from "../utils/env.js";
import axios from "axios";

let headers = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

if (sessionStorage.apitoken) {
  headers["Authorization"] = "Token " + sessionStorage.apitoken;
}

const apiClient = axios.create({
  baseURL: env.ameliaAddr,
  //~ baseURL: 'https://ameliatest.initialview.com',
  //~ baseURL: 'localhost:8080',
  //~ withCredentials: true,
  headers: headers
});

// A swept auth token (see shield/user/tasks.py expire_stale_auth_tokens) 401s every
// call from here on, with nothing else to catch it: fetchUser()'s .catch() in
// base-components-pack.js only stops the spinner, and LoginRequired.js only redirects
// when sessionStorage.apitoken is missing outright, not when it's stale. Clear every
// key that can resurrect the dead token (session, and both localStorage keys the
// iframe handoff / setSessionStorageApiToken write to) so the next load actually
// redirects instead of 401ing forever.
//
// HTTP 401 alone isn't enough to mean "this token is dead": every
// is_authenticated_* decorator in shield/initialview/utils.py (is_authenticated_officer
// included) returns the same authentication_error shortcut - body {"status": 41, ...} -
// for a fully valid, logged-in user who just fails some other check (e.g. no
// organization). Only a token TokenAuthentication itself rejects goes through DRF's own
// AuthenticationFailed path, which shield/initialview/exception.py renders with the
// body's status set to the HTTP code: {"status": 401, ...}. Check for that specifically,
// so a valid session doesn't get force-logged-out over an unrelated permission check.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data &&
      error.response.data.status === 401
    ) {
      sessionStorage.removeItem("apitoken");
      localStorage.removeItem("apitoken");
      localStorage.removeItem("token");
      let currentUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;
      window.location.href = "/login/?r=" + encodeURIComponent(currentUrl);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
